import { IGeneralState, SET_PAGE_TITLE, SET_USER_ID_CLAIMS_NAME, SET_IS_APP_READY } from 'store/general/types';
import labels from 'constants/labels';
import { AnyAction } from 'redux';

const initialState: IGeneralState = {
  pageTitle: labels.titles.pages.dashboard,
  userIdClaimsName: '',
  isAppReady: false,
};

export default function(state = initialState, action: AnyAction) {
  switch (action.type) {
    case SET_PAGE_TITLE: {
      return {
        ...state,
        pageTitle: action.pageTitle,
      };
    }

    case SET_USER_ID_CLAIMS_NAME: {
      return {
        ...state,
        userIdClaimsName: action.userIdClaimsName,
      };
    }

    case SET_IS_APP_READY: {
      return {
        ...state,
        isAppReady: action.isAppReady,
      };
    }

    default: {
      return state;
    }
  }
}
